import { initLogging } from "@expert/logging";

import { env } from "./utils/env";

initLogging({ appName: env.appName, commitHash: env.commitHash, logLevel: env.logLevel });
